import Button, { ButtonHTMLTag, ButtonStyle } from '@/app/components/Button/Button';
import DonationList from '@/app/components/DonationList/DonationList';
import { useTranslation } from 'react-i18next';
import { Donation } from '@/app/api';
import ArrowIcon from '@/app/components/ArrowIcon/ArrowIcon';
import { rubik } from '@/app/utils/fonts';
import classNames from 'classnames';

type DonationsSideBarProps = {
  donations?: Donation[];
  onMoreDonorsButtonClick: () => void;
};

export const DonationsSideBar = ({ donations, onMoreDonorsButtonClick }: DonationsSideBarProps) => {
  const { t } = useTranslation();
  return (
    <div className="hidden lg:block w-[360px] grow-0 shrink-0 pl-[24px] relative">
      <h3
        className={classNames(
          rubik.className,
          'mb-[16px] text-[12px] tracking-[4.5px] font-medium uppercase leading-[24px] text-balance',
        )}
      >
        {t('pages.collection.messages')}
      </h3>
      {!!donations && <DonationList donations={donations} />}
      <Button
        tagSpecificProps={{ htmlTag: ButtonHTMLTag.BUTTON, onClick: onMoreDonorsButtonClick }}
        style={ButtonStyle.PRIMARY_LINK}
        className="group"
      >
        {t('pages.collection.moreDonorsButton')}
        <ArrowIcon className="inline mb-[2px] ml-[8px] group-hover:ml-[12px] transition-all" />
      </Button>
    </div>
  );
};
